/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const AttributeFieldsFragmentDoc = gql`
    fragment AttributeFields on Attribute {
  id
  name
  label
  description
  valueType
  referenceTarget
  kind
  options {
    id
    value
    displayOrder
  }
}
    `;
export const VaultDocumentSearchFieldsFragmentDoc = gql`
    fragment VaultDocumentSearchFields on VaultDocument {
  publicRefId
  spaceId
  status
  createdAt
  updatedAt
  currentVersion {
    ssbVersionNumber
    filename
    contentType
  }
  attributeValues {
    attribute {
      id
      options {
        id
        value
      }
    }
    isSet
    valueText
    valueNumber
    valueDate
    valueBoolean
    valueIds
    valueArenaList {
      id
      name
    }
    valueEntityList {
      id
      name
    }
    valueLpUserList {
      id
      account {
        id
        name
      }
    }
  }
}
    `;
export const VaultDocumentVersionFieldsFragmentDoc = gql`
    fragment VaultDocumentVersionFields on VaultDocumentVersion {
  ssbVersionNumber
  filename
  contentType
  sizeBytes
  uploadedBy
  createdAt
  changeNote
}
    `;
export const SpaceAttributeFieldsFragmentDoc = gql`
    fragment SpaceAttributeFields on Attribute {
  id
  name
  label
  description
  valueType
  referenceTarget
  kind
  options {
    id
    value
    displayOrder
  }
}
    `;
export const SpaceFieldsFragmentDoc = gql`
    fragment SpaceFields on Space {
  id
  name
  description
  domain
  appliesToAllClients
  clients
  clientArenas {
    id
    name
  }
  createdBy
  updatedBy
  createdAt
  updatedAt
  attributes {
    id
    spaceId
    qualityContract
    displayOrder
    attribute {
      ...SpaceAttributeFields
    }
  }
}
    ${SpaceAttributeFieldsFragmentDoc}`;
export const CreateGlobalAttributeDocument = gql`
    mutation CreateGlobalAttribute($input: CreateGlobalAttributeInput!) {
  createGlobalAttribute(input: $input) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;
export type CreateGlobalAttributeMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateGlobalAttributeMutation, GraphqlTypes.CreateGlobalAttributeMutationVariables>;

/**
 * __useCreateGlobalAttributeMutation__
 *
 * To run a mutation, you first call `useCreateGlobalAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalAttributeMutation, { data, loading, error }] = useCreateGlobalAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGlobalAttributeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateGlobalAttributeMutation, GraphqlTypes.CreateGlobalAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateGlobalAttributeMutation, GraphqlTypes.CreateGlobalAttributeMutationVariables>(CreateGlobalAttributeDocument, options);
      }
export type CreateGlobalAttributeMutationHookResult = ReturnType<typeof useCreateGlobalAttributeMutation>;
export type CreateGlobalAttributeMutationResult = Apollo.MutationResult<GraphqlTypes.CreateGlobalAttributeMutation>;
export type CreateGlobalAttributeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateGlobalAttributeMutation, GraphqlTypes.CreateGlobalAttributeMutationVariables>;
export const UpdateGlobalAttributeDocument = gql`
    mutation UpdateGlobalAttribute($id: ID!, $input: UpdateAttributeInput!) {
  updateGlobalAttribute(id: $id, input: $input) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;
export type UpdateGlobalAttributeMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateGlobalAttributeMutation, GraphqlTypes.UpdateGlobalAttributeMutationVariables>;

/**
 * __useUpdateGlobalAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalAttributeMutation, { data, loading, error }] = useUpdateGlobalAttributeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGlobalAttributeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateGlobalAttributeMutation, GraphqlTypes.UpdateGlobalAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateGlobalAttributeMutation, GraphqlTypes.UpdateGlobalAttributeMutationVariables>(UpdateGlobalAttributeDocument, options);
      }
export type UpdateGlobalAttributeMutationHookResult = ReturnType<typeof useUpdateGlobalAttributeMutation>;
export type UpdateGlobalAttributeMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateGlobalAttributeMutation>;
export type UpdateGlobalAttributeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateGlobalAttributeMutation, GraphqlTypes.UpdateGlobalAttributeMutationVariables>;
export const PromoteAttributeToGlobalDocument = gql`
    mutation PromoteAttributeToGlobal($id: ID!, $label: String) {
  promoteAttributeToGlobal(id: $id, label: $label) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;
export type PromoteAttributeToGlobalMutationFn = Apollo.MutationFunction<GraphqlTypes.PromoteAttributeToGlobalMutation, GraphqlTypes.PromoteAttributeToGlobalMutationVariables>;

/**
 * __usePromoteAttributeToGlobalMutation__
 *
 * To run a mutation, you first call `usePromoteAttributeToGlobalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteAttributeToGlobalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteAttributeToGlobalMutation, { data, loading, error }] = usePromoteAttributeToGlobalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      label: // value for 'label'
 *   },
 * });
 */
export function usePromoteAttributeToGlobalMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.PromoteAttributeToGlobalMutation, GraphqlTypes.PromoteAttributeToGlobalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.PromoteAttributeToGlobalMutation, GraphqlTypes.PromoteAttributeToGlobalMutationVariables>(PromoteAttributeToGlobalDocument, options);
      }
export type PromoteAttributeToGlobalMutationHookResult = ReturnType<typeof usePromoteAttributeToGlobalMutation>;
export type PromoteAttributeToGlobalMutationResult = Apollo.MutationResult<GraphqlTypes.PromoteAttributeToGlobalMutation>;
export type PromoteAttributeToGlobalMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.PromoteAttributeToGlobalMutation, GraphqlTypes.PromoteAttributeToGlobalMutationVariables>;
export const DeleteSpaceLocalAttributeDocument = gql`
    mutation DeleteSpaceLocalAttribute($id: ID!) {
  deleteSpaceLocalAttribute(id: $id) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;
export type DeleteSpaceLocalAttributeMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteSpaceLocalAttributeMutation, GraphqlTypes.DeleteSpaceLocalAttributeMutationVariables>;

/**
 * __useDeleteSpaceLocalAttributeMutation__
 *
 * To run a mutation, you first call `useDeleteSpaceLocalAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpaceLocalAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpaceLocalAttributeMutation, { data, loading, error }] = useDeleteSpaceLocalAttributeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSpaceLocalAttributeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteSpaceLocalAttributeMutation, GraphqlTypes.DeleteSpaceLocalAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteSpaceLocalAttributeMutation, GraphqlTypes.DeleteSpaceLocalAttributeMutationVariables>(DeleteSpaceLocalAttributeDocument, options);
      }
export type DeleteSpaceLocalAttributeMutationHookResult = ReturnType<typeof useDeleteSpaceLocalAttributeMutation>;
export type DeleteSpaceLocalAttributeMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteSpaceLocalAttributeMutation>;
export type DeleteSpaceLocalAttributeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteSpaceLocalAttributeMutation, GraphqlTypes.DeleteSpaceLocalAttributeMutationVariables>;
export const UpdateSpaceLocalAttributeDocument = gql`
    mutation UpdateSpaceLocalAttribute($input: UpdateSpaceLocalAttributeInput!) {
  updateSpaceLocalAttribute(input: $input) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;
export type UpdateSpaceLocalAttributeMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateSpaceLocalAttributeMutation, GraphqlTypes.UpdateSpaceLocalAttributeMutationVariables>;

/**
 * __useUpdateSpaceLocalAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceLocalAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceLocalAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceLocalAttributeMutation, { data, loading, error }] = useUpdateSpaceLocalAttributeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceLocalAttributeMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateSpaceLocalAttributeMutation, GraphqlTypes.UpdateSpaceLocalAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateSpaceLocalAttributeMutation, GraphqlTypes.UpdateSpaceLocalAttributeMutationVariables>(UpdateSpaceLocalAttributeDocument, options);
      }
export type UpdateSpaceLocalAttributeMutationHookResult = ReturnType<typeof useUpdateSpaceLocalAttributeMutation>;
export type UpdateSpaceLocalAttributeMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateSpaceLocalAttributeMutation>;
export type UpdateSpaceLocalAttributeMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateSpaceLocalAttributeMutation, GraphqlTypes.UpdateSpaceLocalAttributeMutationVariables>;
export const AttributesDocument = gql`
    query Attributes($kind: String) {
  attributes(kind: $kind) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;

/**
 * __useAttributesQuery__
 *
 * To run a query within a React component, call `useAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributesQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useAttributesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>(AttributesDocument, options);
      }
export function useAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>(AttributesDocument, options);
        }
// @ts-ignore
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>;
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AttributesQuery | undefined, GraphqlTypes.AttributesQueryVariables>;
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>(AttributesDocument, options);
        }
export type AttributesQueryHookResult = ReturnType<typeof useAttributesQuery>;
export type AttributesLazyQueryHookResult = ReturnType<typeof useAttributesLazyQuery>;
export type AttributesSuspenseQueryHookResult = ReturnType<typeof useAttributesSuspenseQuery>;
export type AttributesQueryResult = Apollo.QueryResult<GraphqlTypes.AttributesQuery, GraphqlTypes.AttributesQueryVariables>;
export const GlobalAttributesDocument = gql`
    query GlobalAttributes($includeSystemBound: Boolean = true, $includeStewardBound: Boolean = true) {
  globalAttributes(
    includeSystemBound: $includeSystemBound
    includeStewardBound: $includeStewardBound
  ) {
    ...AttributeFields
  }
}
    ${AttributeFieldsFragmentDoc}`;

/**
 * __useGlobalAttributesQuery__
 *
 * To run a query within a React component, call `useGlobalAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalAttributesQuery({
 *   variables: {
 *      includeSystemBound: // value for 'includeSystemBound'
 *      includeStewardBound: // value for 'includeStewardBound'
 *   },
 * });
 */
export function useGlobalAttributesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>(GlobalAttributesDocument, options);
      }
export function useGlobalAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>(GlobalAttributesDocument, options);
        }
// @ts-ignore
export function useGlobalAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>;
export function useGlobalAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GlobalAttributesQuery | undefined, GraphqlTypes.GlobalAttributesQueryVariables>;
export function useGlobalAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>(GlobalAttributesDocument, options);
        }
export type GlobalAttributesQueryHookResult = ReturnType<typeof useGlobalAttributesQuery>;
export type GlobalAttributesLazyQueryHookResult = ReturnType<typeof useGlobalAttributesLazyQuery>;
export type GlobalAttributesSuspenseQueryHookResult = ReturnType<typeof useGlobalAttributesSuspenseQuery>;
export type GlobalAttributesQueryResult = Apollo.QueryResult<GraphqlTypes.GlobalAttributesQuery, GraphqlTypes.GlobalAttributesQueryVariables>;
export const SpaceLocalAttributesSearchDocument = gql`
    query SpaceLocalAttributesSearch($input: SpaceLocalAttributesInput!) {
  spaceLocalAttributesSearch(input: $input) {
    nodes {
      id
      qualityContract
      displayOrder
      space {
        id
        name
        domain
      }
      attribute {
        ...AttributeFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${AttributeFieldsFragmentDoc}`;

/**
 * __useSpaceLocalAttributesSearchQuery__
 *
 * To run a query within a React component, call `useSpaceLocalAttributesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceLocalAttributesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceLocalAttributesSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpaceLocalAttributesSearchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables> & ({ variables: GraphqlTypes.SpaceLocalAttributesSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>(SpaceLocalAttributesSearchDocument, options);
      }
export function useSpaceLocalAttributesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>(SpaceLocalAttributesSearchDocument, options);
        }
// @ts-ignore
export function useSpaceLocalAttributesSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>;
export function useSpaceLocalAttributesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpaceLocalAttributesSearchQuery | undefined, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>;
export function useSpaceLocalAttributesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>(SpaceLocalAttributesSearchDocument, options);
        }
export type SpaceLocalAttributesSearchQueryHookResult = ReturnType<typeof useSpaceLocalAttributesSearchQuery>;
export type SpaceLocalAttributesSearchLazyQueryHookResult = ReturnType<typeof useSpaceLocalAttributesSearchLazyQuery>;
export type SpaceLocalAttributesSearchSuspenseQueryHookResult = ReturnType<typeof useSpaceLocalAttributesSearchSuspenseQuery>;
export type SpaceLocalAttributesSearchQueryResult = Apollo.QueryResult<GraphqlTypes.SpaceLocalAttributesSearchQuery, GraphqlTypes.SpaceLocalAttributesSearchQueryVariables>;
export const AttributePromotionPreflightDocument = gql`
    query AttributePromotionPreflight($id: ID!, $label: String) {
  attributePromotionPreflight(id: $id, label: $label) {
    attributeId
    label
    promotable
    blockers
    labelConflicts {
      attributeId
      kind
      label
      spaces {
        id
        name
        domain
      }
    }
  }
}
    `;

/**
 * __useAttributePromotionPreflightQuery__
 *
 * To run a query within a React component, call `useAttributePromotionPreflightQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributePromotionPreflightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributePromotionPreflightQuery({
 *   variables: {
 *      id: // value for 'id'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useAttributePromotionPreflightQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables> & ({ variables: GraphqlTypes.AttributePromotionPreflightQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>(AttributePromotionPreflightDocument, options);
      }
export function useAttributePromotionPreflightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>(AttributePromotionPreflightDocument, options);
        }
// @ts-ignore
export function useAttributePromotionPreflightSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>;
export function useAttributePromotionPreflightSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AttributePromotionPreflightQuery | undefined, GraphqlTypes.AttributePromotionPreflightQueryVariables>;
export function useAttributePromotionPreflightSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>(AttributePromotionPreflightDocument, options);
        }
export type AttributePromotionPreflightQueryHookResult = ReturnType<typeof useAttributePromotionPreflightQuery>;
export type AttributePromotionPreflightLazyQueryHookResult = ReturnType<typeof useAttributePromotionPreflightLazyQuery>;
export type AttributePromotionPreflightSuspenseQueryHookResult = ReturnType<typeof useAttributePromotionPreflightSuspenseQuery>;
export type AttributePromotionPreflightQueryResult = Apollo.QueryResult<GraphqlTypes.AttributePromotionPreflightQuery, GraphqlTypes.AttributePromotionPreflightQueryVariables>;
export const AttributeDeletionImpactDocument = gql`
    query AttributeDeletionImpact($id: ID!) {
  attributeDeletionImpact(id: $id) {
    attributeId
    documentCount
  }
}
    `;

/**
 * __useAttributeDeletionImpactQuery__
 *
 * To run a query within a React component, call `useAttributeDeletionImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeDeletionImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeDeletionImpactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttributeDeletionImpactQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables> & ({ variables: GraphqlTypes.AttributeDeletionImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>(AttributeDeletionImpactDocument, options);
      }
export function useAttributeDeletionImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>(AttributeDeletionImpactDocument, options);
        }
// @ts-ignore
export function useAttributeDeletionImpactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>;
export function useAttributeDeletionImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.AttributeDeletionImpactQuery | undefined, GraphqlTypes.AttributeDeletionImpactQueryVariables>;
export function useAttributeDeletionImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>(AttributeDeletionImpactDocument, options);
        }
export type AttributeDeletionImpactQueryHookResult = ReturnType<typeof useAttributeDeletionImpactQuery>;
export type AttributeDeletionImpactLazyQueryHookResult = ReturnType<typeof useAttributeDeletionImpactLazyQuery>;
export type AttributeDeletionImpactSuspenseQueryHookResult = ReturnType<typeof useAttributeDeletionImpactSuspenseQuery>;
export type AttributeDeletionImpactQueryResult = Apollo.QueryResult<GraphqlTypes.AttributeDeletionImpactQuery, GraphqlTypes.AttributeDeletionImpactQueryVariables>;
export const SpaceLocalAttributeValueSetDocument = gql`
    query SpaceLocalAttributeValueSet($input: SpaceLocalAttributesInput!) {
  spaceLocalAttributesSearch(input: $input) {
    nodes {
      attribute {
        id
        options {
          id
          value
          displayOrder
        }
      }
    }
  }
}
    `;

/**
 * __useSpaceLocalAttributeValueSetQuery__
 *
 * To run a query within a React component, call `useSpaceLocalAttributeValueSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceLocalAttributeValueSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceLocalAttributeValueSetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpaceLocalAttributeValueSetQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables> & ({ variables: GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>(SpaceLocalAttributeValueSetDocument, options);
      }
export function useSpaceLocalAttributeValueSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>(SpaceLocalAttributeValueSetDocument, options);
        }
// @ts-ignore
export function useSpaceLocalAttributeValueSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>;
export function useSpaceLocalAttributeValueSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpaceLocalAttributeValueSetQuery | undefined, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>;
export function useSpaceLocalAttributeValueSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>(SpaceLocalAttributeValueSetDocument, options);
        }
export type SpaceLocalAttributeValueSetQueryHookResult = ReturnType<typeof useSpaceLocalAttributeValueSetQuery>;
export type SpaceLocalAttributeValueSetLazyQueryHookResult = ReturnType<typeof useSpaceLocalAttributeValueSetLazyQuery>;
export type SpaceLocalAttributeValueSetSuspenseQueryHookResult = ReturnType<typeof useSpaceLocalAttributeValueSetSuspenseQuery>;
export type SpaceLocalAttributeValueSetQueryResult = Apollo.QueryResult<GraphqlTypes.SpaceLocalAttributeValueSetQuery, GraphqlTypes.SpaceLocalAttributeValueSetQueryVariables>;
export const CreateVaultDocumentDocument = gql`
    mutation CreateVaultDocument($input: CreateVaultDocumentInput!) {
  createVaultDocument(input: $input) {
    document {
      publicRefId
      spaceId
      status
    }
    uploadTarget {
      publicRefId
      ssbVersionNumber
      url
      method
      headers {
        name
        value
      }
      expiresIn
    }
    multipartPlan {
      publicRefId
      ssbVersionNumber
      partCount
      partSizeBytes
    }
  }
}
    `;
export type CreateVaultDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateVaultDocumentMutation, GraphqlTypes.CreateVaultDocumentMutationVariables>;

/**
 * __useCreateVaultDocumentMutation__
 *
 * To run a mutation, you first call `useCreateVaultDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVaultDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVaultDocumentMutation, { data, loading, error }] = useCreateVaultDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVaultDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateVaultDocumentMutation, GraphqlTypes.CreateVaultDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateVaultDocumentMutation, GraphqlTypes.CreateVaultDocumentMutationVariables>(CreateVaultDocumentDocument, options);
      }
export type CreateVaultDocumentMutationHookResult = ReturnType<typeof useCreateVaultDocumentMutation>;
export type CreateVaultDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.CreateVaultDocumentMutation>;
export type CreateVaultDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateVaultDocumentMutation, GraphqlTypes.CreateVaultDocumentMutationVariables>;
export const CreateVaultDocumentsBatchDocument = gql`
    mutation CreateVaultDocumentsBatch($input: CreateVaultDocumentsBatchInput!) {
  createVaultDocumentsBatch(input: $input) {
    documents {
      publicRefId
      spaceId
      status
    }
    uploadTargets {
      publicRefId
      ssbVersionNumber
      url
      method
      headers {
        name
        value
      }
      expiresIn
    }
  }
}
    `;
export type CreateVaultDocumentsBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateVaultDocumentsBatchMutation, GraphqlTypes.CreateVaultDocumentsBatchMutationVariables>;

/**
 * __useCreateVaultDocumentsBatchMutation__
 *
 * To run a mutation, you first call `useCreateVaultDocumentsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVaultDocumentsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVaultDocumentsBatchMutation, { data, loading, error }] = useCreateVaultDocumentsBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVaultDocumentsBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateVaultDocumentsBatchMutation, GraphqlTypes.CreateVaultDocumentsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateVaultDocumentsBatchMutation, GraphqlTypes.CreateVaultDocumentsBatchMutationVariables>(CreateVaultDocumentsBatchDocument, options);
      }
export type CreateVaultDocumentsBatchMutationHookResult = ReturnType<typeof useCreateVaultDocumentsBatchMutation>;
export type CreateVaultDocumentsBatchMutationResult = Apollo.MutationResult<GraphqlTypes.CreateVaultDocumentsBatchMutation>;
export type CreateVaultDocumentsBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateVaultDocumentsBatchMutation, GraphqlTypes.CreateVaultDocumentsBatchMutationVariables>;
export const FinalizeVaultDocumentsBatchDocument = gql`
    mutation FinalizeVaultDocumentsBatch($inputs: [FinalizeVaultDocumentInput!]!) {
  finalizeVaultDocumentsBatch(inputs: $inputs) {
    documents {
      publicRefId
      spaceId
      status
    }
    failed {
      index
      reason
    }
  }
}
    `;
export type FinalizeVaultDocumentsBatchMutationFn = Apollo.MutationFunction<GraphqlTypes.FinalizeVaultDocumentsBatchMutation, GraphqlTypes.FinalizeVaultDocumentsBatchMutationVariables>;

/**
 * __useFinalizeVaultDocumentsBatchMutation__
 *
 * To run a mutation, you first call `useFinalizeVaultDocumentsBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeVaultDocumentsBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeVaultDocumentsBatchMutation, { data, loading, error }] = useFinalizeVaultDocumentsBatchMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useFinalizeVaultDocumentsBatchMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinalizeVaultDocumentsBatchMutation, GraphqlTypes.FinalizeVaultDocumentsBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinalizeVaultDocumentsBatchMutation, GraphqlTypes.FinalizeVaultDocumentsBatchMutationVariables>(FinalizeVaultDocumentsBatchDocument, options);
      }
export type FinalizeVaultDocumentsBatchMutationHookResult = ReturnType<typeof useFinalizeVaultDocumentsBatchMutation>;
export type FinalizeVaultDocumentsBatchMutationResult = Apollo.MutationResult<GraphqlTypes.FinalizeVaultDocumentsBatchMutation>;
export type FinalizeVaultDocumentsBatchMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinalizeVaultDocumentsBatchMutation, GraphqlTypes.FinalizeVaultDocumentsBatchMutationVariables>;
export const SignVaultDocumentPartsDocument = gql`
    mutation SignVaultDocumentParts($input: SignVaultDocumentPartsInput!) {
  signVaultDocumentParts(input: $input) {
    partNumber
    url
    expiresIn
  }
}
    `;
export type SignVaultDocumentPartsMutationFn = Apollo.MutationFunction<GraphqlTypes.SignVaultDocumentPartsMutation, GraphqlTypes.SignVaultDocumentPartsMutationVariables>;

/**
 * __useSignVaultDocumentPartsMutation__
 *
 * To run a mutation, you first call `useSignVaultDocumentPartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignVaultDocumentPartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signVaultDocumentPartsMutation, { data, loading, error }] = useSignVaultDocumentPartsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignVaultDocumentPartsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SignVaultDocumentPartsMutation, GraphqlTypes.SignVaultDocumentPartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SignVaultDocumentPartsMutation, GraphqlTypes.SignVaultDocumentPartsMutationVariables>(SignVaultDocumentPartsDocument, options);
      }
export type SignVaultDocumentPartsMutationHookResult = ReturnType<typeof useSignVaultDocumentPartsMutation>;
export type SignVaultDocumentPartsMutationResult = Apollo.MutationResult<GraphqlTypes.SignVaultDocumentPartsMutation>;
export type SignVaultDocumentPartsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SignVaultDocumentPartsMutation, GraphqlTypes.SignVaultDocumentPartsMutationVariables>;
export const FinalizeVaultDocumentDocument = gql`
    mutation FinalizeVaultDocument($input: FinalizeVaultDocumentInput!) {
  finalizeVaultDocument(input: $input) {
    publicRefId
    spaceId
    status
  }
}
    `;
export type FinalizeVaultDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.FinalizeVaultDocumentMutation, GraphqlTypes.FinalizeVaultDocumentMutationVariables>;

/**
 * __useFinalizeVaultDocumentMutation__
 *
 * To run a mutation, you first call `useFinalizeVaultDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeVaultDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeVaultDocumentMutation, { data, loading, error }] = useFinalizeVaultDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeVaultDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.FinalizeVaultDocumentMutation, GraphqlTypes.FinalizeVaultDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.FinalizeVaultDocumentMutation, GraphqlTypes.FinalizeVaultDocumentMutationVariables>(FinalizeVaultDocumentDocument, options);
      }
export type FinalizeVaultDocumentMutationHookResult = ReturnType<typeof useFinalizeVaultDocumentMutation>;
export type FinalizeVaultDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.FinalizeVaultDocumentMutation>;
export type FinalizeVaultDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.FinalizeVaultDocumentMutation, GraphqlTypes.FinalizeVaultDocumentMutationVariables>;
export const ReplaceVaultDocumentDocument = gql`
    mutation ReplaceVaultDocument($input: ReplaceVaultDocumentInput!) {
  replaceVaultDocument(input: $input) {
    document {
      publicRefId
      spaceId
      status
    }
    ssbVersionNumber
    uploadTarget {
      publicRefId
      ssbVersionNumber
      url
      method
      headers {
        name
        value
      }
      expiresIn
    }
  }
}
    `;
export type ReplaceVaultDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.ReplaceVaultDocumentMutation, GraphqlTypes.ReplaceVaultDocumentMutationVariables>;

/**
 * __useReplaceVaultDocumentMutation__
 *
 * To run a mutation, you first call `useReplaceVaultDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceVaultDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceVaultDocumentMutation, { data, loading, error }] = useReplaceVaultDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceVaultDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReplaceVaultDocumentMutation, GraphqlTypes.ReplaceVaultDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReplaceVaultDocumentMutation, GraphqlTypes.ReplaceVaultDocumentMutationVariables>(ReplaceVaultDocumentDocument, options);
      }
export type ReplaceVaultDocumentMutationHookResult = ReturnType<typeof useReplaceVaultDocumentMutation>;
export type ReplaceVaultDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.ReplaceVaultDocumentMutation>;
export type ReplaceVaultDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReplaceVaultDocumentMutation, GraphqlTypes.ReplaceVaultDocumentMutationVariables>;
export const UpdateVaultDocumentDocument = gql`
    mutation UpdateVaultDocument($input: UpdateVaultDocumentInput!) {
  updateVaultDocument(input: $input) {
    ...VaultDocumentSearchFields
  }
}
    ${VaultDocumentSearchFieldsFragmentDoc}`;
export type UpdateVaultDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateVaultDocumentMutation, GraphqlTypes.UpdateVaultDocumentMutationVariables>;

/**
 * __useUpdateVaultDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateVaultDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVaultDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVaultDocumentMutation, { data, loading, error }] = useUpdateVaultDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVaultDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateVaultDocumentMutation, GraphqlTypes.UpdateVaultDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateVaultDocumentMutation, GraphqlTypes.UpdateVaultDocumentMutationVariables>(UpdateVaultDocumentDocument, options);
      }
export type UpdateVaultDocumentMutationHookResult = ReturnType<typeof useUpdateVaultDocumentMutation>;
export type UpdateVaultDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateVaultDocumentMutation>;
export type UpdateVaultDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateVaultDocumentMutation, GraphqlTypes.UpdateVaultDocumentMutationVariables>;
export const VaultDocumentsSearchDocument = gql`
    query VaultDocumentsSearch($input: VaultDocumentsInput!) {
  vaultDocumentsSearch(input: $input) {
    nodes {
      ...VaultDocumentSearchFields
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${VaultDocumentSearchFieldsFragmentDoc}`;

/**
 * __useVaultDocumentsSearchQuery__
 *
 * To run a query within a React component, call `useVaultDocumentsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaultDocumentsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaultDocumentsSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVaultDocumentsSearchQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables> & ({ variables: GraphqlTypes.VaultDocumentsSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>(VaultDocumentsSearchDocument, options);
      }
export function useVaultDocumentsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>(VaultDocumentsSearchDocument, options);
        }
// @ts-ignore
export function useVaultDocumentsSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>;
export function useVaultDocumentsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultDocumentsSearchQuery | undefined, GraphqlTypes.VaultDocumentsSearchQueryVariables>;
export function useVaultDocumentsSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>(VaultDocumentsSearchDocument, options);
        }
export type VaultDocumentsSearchQueryHookResult = ReturnType<typeof useVaultDocumentsSearchQuery>;
export type VaultDocumentsSearchLazyQueryHookResult = ReturnType<typeof useVaultDocumentsSearchLazyQuery>;
export type VaultDocumentsSearchSuspenseQueryHookResult = ReturnType<typeof useVaultDocumentsSearchSuspenseQuery>;
export type VaultDocumentsSearchQueryResult = Apollo.QueryResult<GraphqlTypes.VaultDocumentsSearchQuery, GraphqlTypes.VaultDocumentsSearchQueryVariables>;
export const VaultDocumentByRefDocument = gql`
    query VaultDocumentByRef($publicRefId: UUID!) {
  vaultDocumentByRef(publicRefId: $publicRefId) {
    ...VaultDocumentSearchFields
    versions {
      ...VaultDocumentVersionFields
    }
  }
}
    ${VaultDocumentSearchFieldsFragmentDoc}
${VaultDocumentVersionFieldsFragmentDoc}`;

/**
 * __useVaultDocumentByRefQuery__
 *
 * To run a query within a React component, call `useVaultDocumentByRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaultDocumentByRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaultDocumentByRefQuery({
 *   variables: {
 *      publicRefId: // value for 'publicRefId'
 *   },
 * });
 */
export function useVaultDocumentByRefQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables> & ({ variables: GraphqlTypes.VaultDocumentByRefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>(VaultDocumentByRefDocument, options);
      }
export function useVaultDocumentByRefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>(VaultDocumentByRefDocument, options);
        }
// @ts-ignore
export function useVaultDocumentByRefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>;
export function useVaultDocumentByRefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultDocumentByRefQuery | undefined, GraphqlTypes.VaultDocumentByRefQueryVariables>;
export function useVaultDocumentByRefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>(VaultDocumentByRefDocument, options);
        }
export type VaultDocumentByRefQueryHookResult = ReturnType<typeof useVaultDocumentByRefQuery>;
export type VaultDocumentByRefLazyQueryHookResult = ReturnType<typeof useVaultDocumentByRefLazyQuery>;
export type VaultDocumentByRefSuspenseQueryHookResult = ReturnType<typeof useVaultDocumentByRefSuspenseQuery>;
export type VaultDocumentByRefQueryResult = Apollo.QueryResult<GraphqlTypes.VaultDocumentByRefQuery, GraphqlTypes.VaultDocumentByRefQueryVariables>;
export const VaultDocumentDownloadUrlDocument = gql`
    query VaultDocumentDownloadUrl($publicRefId: UUID!, $ssbVersionNumber: Int) {
  vaultDocumentDownloadUrl(
    publicRefId: $publicRefId
    ssbVersionNumber: $ssbVersionNumber
  ) {
    url
    expiresIn
  }
}
    `;

/**
 * __useVaultDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useVaultDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaultDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaultDocumentDownloadUrlQuery({
 *   variables: {
 *      publicRefId: // value for 'publicRefId'
 *      ssbVersionNumber: // value for 'ssbVersionNumber'
 *   },
 * });
 */
export function useVaultDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.VaultDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>(VaultDocumentDownloadUrlDocument, options);
      }
export function useVaultDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>(VaultDocumentDownloadUrlDocument, options);
        }
// @ts-ignore
export function useVaultDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>;
export function useVaultDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultDocumentDownloadUrlQuery | undefined, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>;
export function useVaultDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>(VaultDocumentDownloadUrlDocument, options);
        }
export type VaultDocumentDownloadUrlQueryHookResult = ReturnType<typeof useVaultDocumentDownloadUrlQuery>;
export type VaultDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useVaultDocumentDownloadUrlLazyQuery>;
export type VaultDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useVaultDocumentDownloadUrlSuspenseQuery>;
export type VaultDocumentDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.VaultDocumentDownloadUrlQuery, GraphqlTypes.VaultDocumentDownloadUrlQueryVariables>;
export const VaultArenaNamesDocument = gql`
    query VaultArenaNames($arenaIds: [ID!]) {
  arenas(arenaIds: $arenaIds, first: 100) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useVaultArenaNamesQuery__
 *
 * To run a query within a React component, call `useVaultArenaNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaultArenaNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaultArenaNamesQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *   },
 * });
 */
export function useVaultArenaNamesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>(VaultArenaNamesDocument, options);
      }
export function useVaultArenaNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>(VaultArenaNamesDocument, options);
        }
// @ts-ignore
export function useVaultArenaNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>;
export function useVaultArenaNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultArenaNamesQuery | undefined, GraphqlTypes.VaultArenaNamesQueryVariables>;
export function useVaultArenaNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>(VaultArenaNamesDocument, options);
        }
export type VaultArenaNamesQueryHookResult = ReturnType<typeof useVaultArenaNamesQuery>;
export type VaultArenaNamesLazyQueryHookResult = ReturnType<typeof useVaultArenaNamesLazyQuery>;
export type VaultArenaNamesSuspenseQueryHookResult = ReturnType<typeof useVaultArenaNamesSuspenseQuery>;
export type VaultArenaNamesQueryResult = Apollo.QueryResult<GraphqlTypes.VaultArenaNamesQuery, GraphqlTypes.VaultArenaNamesQueryVariables>;
export const VaultEntityNamesDocument = gql`
    query VaultEntityNames($arenaIds: [ID!], $entityIds: [ID!]) {
  dataVaultEntities(
    input: {arenaIds: $arenaIds, entityIds: $entityIds}
    first: 100
  ) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useVaultEntityNamesQuery__
 *
 * To run a query within a React component, call `useVaultEntityNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaultEntityNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaultEntityNamesQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useVaultEntityNamesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>(VaultEntityNamesDocument, options);
      }
export function useVaultEntityNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>(VaultEntityNamesDocument, options);
        }
// @ts-ignore
export function useVaultEntityNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>;
export function useVaultEntityNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultEntityNamesQuery | undefined, GraphqlTypes.VaultEntityNamesQueryVariables>;
export function useVaultEntityNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>(VaultEntityNamesDocument, options);
        }
export type VaultEntityNamesQueryHookResult = ReturnType<typeof useVaultEntityNamesQuery>;
export type VaultEntityNamesLazyQueryHookResult = ReturnType<typeof useVaultEntityNamesLazyQuery>;
export type VaultEntityNamesSuspenseQueryHookResult = ReturnType<typeof useVaultEntityNamesSuspenseQuery>;
export type VaultEntityNamesQueryResult = Apollo.QueryResult<GraphqlTypes.VaultEntityNamesQuery, GraphqlTypes.VaultEntityNamesQueryVariables>;
export const VaultInvestorPositionNamesDocument = gql`
    query VaultInvestorPositionNames($arenaIds: [ID!], $entityIds: [ID!]) {
  dataVaultEntities(
    input: {arenaIds: $arenaIds, entityIds: $entityIds}
    first: 100
  ) {
    edges {
      node {
        id
        owningInvestorPositions {
          edges {
            node {
              id
              account {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useVaultInvestorPositionNamesQuery__
 *
 * To run a query within a React component, call `useVaultInvestorPositionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaultInvestorPositionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaultInvestorPositionNamesQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useVaultInvestorPositionNamesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>(VaultInvestorPositionNamesDocument, options);
      }
export function useVaultInvestorPositionNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>(VaultInvestorPositionNamesDocument, options);
        }
// @ts-ignore
export function useVaultInvestorPositionNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>;
export function useVaultInvestorPositionNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.VaultInvestorPositionNamesQuery | undefined, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>;
export function useVaultInvestorPositionNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>(VaultInvestorPositionNamesDocument, options);
        }
export type VaultInvestorPositionNamesQueryHookResult = ReturnType<typeof useVaultInvestorPositionNamesQuery>;
export type VaultInvestorPositionNamesLazyQueryHookResult = ReturnType<typeof useVaultInvestorPositionNamesLazyQuery>;
export type VaultInvestorPositionNamesSuspenseQueryHookResult = ReturnType<typeof useVaultInvestorPositionNamesSuspenseQuery>;
export type VaultInvestorPositionNamesQueryResult = Apollo.QueryResult<GraphqlTypes.VaultInvestorPositionNamesQuery, GraphqlTypes.VaultInvestorPositionNamesQueryVariables>;
export const CreateSpaceDocument = gql`
    mutation CreateSpace($input: CreateSpaceInput!) {
  createSpace(input: $input) {
    ...SpaceFields
  }
}
    ${SpaceFieldsFragmentDoc}`;
export type CreateSpaceMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateSpaceMutation, GraphqlTypes.CreateSpaceMutationVariables>;

/**
 * __useCreateSpaceMutation__
 *
 * To run a mutation, you first call `useCreateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpaceMutation, { data, loading, error }] = useCreateSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpaceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateSpaceMutation, GraphqlTypes.CreateSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateSpaceMutation, GraphqlTypes.CreateSpaceMutationVariables>(CreateSpaceDocument, options);
      }
export type CreateSpaceMutationHookResult = ReturnType<typeof useCreateSpaceMutation>;
export type CreateSpaceMutationResult = Apollo.MutationResult<GraphqlTypes.CreateSpaceMutation>;
export type CreateSpaceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateSpaceMutation, GraphqlTypes.CreateSpaceMutationVariables>;
export const UpdateSpaceDocument = gql`
    mutation UpdateSpace($input: UpdateSpaceInput!) {
  updateSpace(input: $input) {
    ...SpaceFields
  }
}
    ${SpaceFieldsFragmentDoc}`;
export type UpdateSpaceMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateSpaceMutation, GraphqlTypes.UpdateSpaceMutationVariables>;

/**
 * __useUpdateSpaceMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceMutation, { data, loading, error }] = useUpdateSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateSpaceMutation, GraphqlTypes.UpdateSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateSpaceMutation, GraphqlTypes.UpdateSpaceMutationVariables>(UpdateSpaceDocument, options);
      }
export type UpdateSpaceMutationHookResult = ReturnType<typeof useUpdateSpaceMutation>;
export type UpdateSpaceMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateSpaceMutation>;
export type UpdateSpaceMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateSpaceMutation, GraphqlTypes.UpdateSpaceMutationVariables>;
export const SpacesDocument = gql`
    query Spaces($domain: DomainSlug) {
  spaces(domain: $domain) {
    ...SpaceFields
  }
}
    ${SpaceFieldsFragmentDoc}`;

/**
 * __useSpacesQuery__
 *
 * To run a query within a React component, call `useSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpacesQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useSpacesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>(SpacesDocument, options);
      }
export function useSpacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>(SpacesDocument, options);
        }
// @ts-ignore
export function useSpacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>;
export function useSpacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpacesQuery | undefined, GraphqlTypes.SpacesQueryVariables>;
export function useSpacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>(SpacesDocument, options);
        }
export type SpacesQueryHookResult = ReturnType<typeof useSpacesQuery>;
export type SpacesLazyQueryHookResult = ReturnType<typeof useSpacesLazyQuery>;
export type SpacesSuspenseQueryHookResult = ReturnType<typeof useSpacesSuspenseQuery>;
export type SpacesQueryResult = Apollo.QueryResult<GraphqlTypes.SpacesQuery, GraphqlTypes.SpacesQueryVariables>;
export const SpaceDocument = gql`
    query Space($id: ID!) {
  space(id: $id) {
    ...SpaceFields
  }
}
    ${SpaceFieldsFragmentDoc}`;

/**
 * __useSpaceQuery__
 *
 * To run a query within a React component, call `useSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSpaceQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables> & ({ variables: GraphqlTypes.SpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>(SpaceDocument, options);
      }
export function useSpaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>(SpaceDocument, options);
        }
// @ts-ignore
export function useSpaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>;
export function useSpaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.SpaceQuery | undefined, GraphqlTypes.SpaceQueryVariables>;
export function useSpaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>(SpaceDocument, options);
        }
export type SpaceQueryHookResult = ReturnType<typeof useSpaceQuery>;
export type SpaceLazyQueryHookResult = ReturnType<typeof useSpaceLazyQuery>;
export type SpaceSuspenseQueryHookResult = ReturnType<typeof useSpaceSuspenseQuery>;
export type SpaceQueryResult = Apollo.QueryResult<GraphqlTypes.SpaceQuery, GraphqlTypes.SpaceQueryVariables>;
export const GetInvestorPositionsByEntitiesDocument = gql`
    query GetInvestorPositionsByEntities($arenaIds: [ID!]!, $entityIds: [ID!]!) {
  dataVaultEntities(
    input: {arenaIds: $arenaIds, entityIds: $entityIds}
    first: 100
  ) {
    edges {
      node {
        id
        name
        owningInvestorPositions {
          edges {
            node {
              id
              status
              account {
                id
                name
                status
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvestorPositionsByEntitiesQuery__
 *
 * To run a query within a React component, call `useGetInvestorPositionsByEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestorPositionsByEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestorPositionsByEntitiesQuery({
 *   variables: {
 *      arenaIds: // value for 'arenaIds'
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useGetInvestorPositionsByEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables> & ({ variables: GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>(GetInvestorPositionsByEntitiesDocument, options);
      }
export function useGetInvestorPositionsByEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>(GetInvestorPositionsByEntitiesDocument, options);
        }
// @ts-ignore
export function useGetInvestorPositionsByEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>;
export function useGetInvestorPositionsByEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetInvestorPositionsByEntitiesQuery | undefined, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>;
export function useGetInvestorPositionsByEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>(GetInvestorPositionsByEntitiesDocument, options);
        }
export type GetInvestorPositionsByEntitiesQueryHookResult = ReturnType<typeof useGetInvestorPositionsByEntitiesQuery>;
export type GetInvestorPositionsByEntitiesLazyQueryHookResult = ReturnType<typeof useGetInvestorPositionsByEntitiesLazyQuery>;
export type GetInvestorPositionsByEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetInvestorPositionsByEntitiesSuspenseQuery>;
export type GetInvestorPositionsByEntitiesQueryResult = Apollo.QueryResult<GraphqlTypes.GetInvestorPositionsByEntitiesQuery, GraphqlTypes.GetInvestorPositionsByEntitiesQueryVariables>;